import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private subject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  isLoading = false;

  constructor(private loadingController: LoadingController) {
  }

  onNext(): Observable<boolean> {
    return this.subject.asObservable();
  }

  async show() {
    this.isLoading = true;

    return await this.loadingController.create({
      spinner: 'crescent',
      cssClass: 'spinner-wrapper'
    }).then(spinner => {
      if (!this.isLoading) {
        spinner.present().then(() => {
          if (!this.isLoading) { // abort loader
            spinner.dismiss();
          }
        });
      }
    });
  }

  async hide() {
    this.isLoading = false;

    return await this.loadingController.getTop().then(spinner => {
      if (spinner) {
        spinner.dismiss();
      }
    });
  }
}
